__webpack_require__.p = "https://partnership-frontend-nextjs-prod.ackoassets.com/next_assets/464a3209c9f5aacbe146d6c3a628be4201c68319/_next/";